const fetchStatus = {
  pending: "PENDING",
  ok: "OK",
  insufficientGifs: "INSUFFICIENT_GIFS",
  giphyError: "GIPHY_ERROR",
  redisError: "REDIS_ERROR",
  serverError: "SERVER_CONNECTION_ERROR",
  genericError: "GENERIC_ERROR"
}

export default fetchStatus


// WEBPACK FOOTER //
// ./src/js/helpers/fetchStatus.js